module.exports = __webpack_public_path__ + "static/img/2 飞利浦.dc8bc0a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/2 飞利浦.jpeg
// module id = RBdy
// module chunks = 1